import React from 'react';
import BuilderAccessGate from '../components/BuilderAccessGate';

export function withBuilderAccess(WrappedComponent, screenTitle, options = {}) {
  function BuilderProtectedScreen(props) {
    return (
      <BuilderAccessGate
        navigation={props.navigation}
        route={props.route}
        title={screenTitle}
        canAccess={options.canAccess}
        deniedMessage={options.deniedMessage}
      >
        <WrappedComponent {...props} />
      </BuilderAccessGate>
    );
  }

  BuilderProtectedScreen.displayName = `BuilderAccess(${WrappedComponent.displayName || WrappedComponent.name || screenTitle})`;
  return BuilderProtectedScreen;
}
